import React from 'react';
import { withCompletedAttributionsContainer } from '../../../containers/gamification2026/CompletedAttributionsContainer';
import CompletedAttributionsTable from './CompletedAttributionsTable';

const CompletedAttributions = ({ completedSaleAttributions, completedPagination, page, onPageChange }) => {
  return (
    <div className="contracts-layout-content">
      <CompletedAttributionsTable
        completedSaleAttributions={completedSaleAttributions}
        pagination={completedPagination}
        page={page}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default withCompletedAttributionsContainer(CompletedAttributions);
